export function filtersMap(options) {
  let filters = "";
  if (options.filters) {
    for (const [key, value] of Object.entries(options.filters)) {
      const dataMap = Array.isArray(value) ? value : [value];
      dataMap.map(item => {
        if (item) {
          filters += `${filters ? "," : ""}${key}-${item}`
        }
      })
    }
  }
  return {
    ...options,
    filters
  };
}